export function emptyGeneralBoard() {
  return {
    periods: [],
    selectedPeriods: [],
    boardsByPeriod: {}
  };
}

export function normalizeBoardPayload(raw) {
  const data = raw && typeof raw === "object" ? raw : {};
  const periods = Array.isArray(data.periods) ? data.periods : [];
  let selectedPeriods = Array.isArray(data.selectedPeriods)
    ? data.selectedPeriods
    : [];
  let boardsByPeriod =
    data.boardsByPeriod && typeof data.boardsByPeriod === "object"
      ? data.boardsByPeriod
      : null;

  if (!boardsByPeriod) {
    const selectedPeriod = data.selectedPeriod || selectedPeriods[0] || null;
    selectedPeriods = selectedPeriod ? [selectedPeriod] : selectedPeriods;
    boardsByPeriod = {};
    if (selectedPeriod && selectedPeriod.id != null) {
      boardsByPeriod[String(selectedPeriod.id)] = {
        disciplines: data.disciplines || [],
        absencesByRa: data.absencesByRa || {},
        gradeColumns: data.gradeColumns || [],
        gradesByRa: data.gradesByRa || {}
      };
    }
  }

  return {
    periods,
    selectedPeriods,
    boardsByPeriod
  };
}

function mapLookup(map, key) {
  if (!map || key == null) return null;
  if (Object.prototype.hasOwnProperty.call(map, key)) return map[key];
  const matched = Object.keys(map).find(item => String(item) === String(key));
  return matched != null ? map[matched] : null;
}

export function getPeriodBoard(boardsByPeriod, periodId) {
  return mapLookup(boardsByPeriod, periodId) || null;
}

export function visiblePeriodBoards(periods, visiblePeriodIds, boardsByPeriod) {
  const idSet = new Set((visiblePeriodIds || []).map(String));
  return (periods || []).filter(period => idSet.has(String(period.id))).map(period => ({
    period,
    board: getPeriodBoard(boardsByPeriod, period.id) || {
      disciplines: [],
      absencesByRa: {},
      gradeColumns: [],
      gradesByRa: {}
    }
  }));
}

export function sumClassesForVisiblePeriods(periodBoards) {
  return (periodBoards || []).reduce((sum, item) => {
    const disciplines = (item.board && item.board.disciplines) || [];
    return (
      sum +
      disciplines.reduce((discSum, discipline) => {
        const aulas = Number(discipline.aulasTotais);
        return discSum + (Number.isFinite(aulas) ? aulas : 0);
      }, 0)
    );
  }, 0);
}

export function disciplineAbsences(board, ra, idTurmaDisc) {
  const row = mapLookup(board && board.absencesByRa, ra);
  const cell = mapLookup(row && row.disciplines, idTurmaDisc);
  return {
    absences: cell && cell.absences != null ? cell.absences : 0,
    percent: cell && cell.percent != null ? cell.percent : 0
  };
}

export function aggregateStudentTotal(periodBoards, ra) {
  let totalAbsences = 0;
  let totalAllowed = 0;
  let totalAulas = 0;

  (periodBoards || []).forEach(({ board }) => {
    const row = mapLookup(board.absencesByRa, ra);
    const summary = (row && row.total) || (row && row.period);
    if (!summary) {
      ((board.disciplines || [])).forEach(discipline => {
        const cell = disciplineAbsences(board, ra, discipline.idTurmaDisc);
        totalAbsences += cell.absences;
        const max = Number(discipline.maxAbsences);
        totalAllowed += Number.isFinite(max) ? max : 0;
        const aulas = Number(discipline.aulasTotais);
        totalAulas += Number.isFinite(aulas) ? aulas : 0;
      });
      return;
    }
    totalAbsences += Number(summary.absences) || 0;
    totalAllowed += Number(summary.maxAbsences) || 0;
    totalAulas += Number(summary.aulasTotais) || 0;
  });

  return {
    absences: totalAbsences,
    percent:
      totalAllowed > 0 ? Math.round((totalAbsences / totalAllowed) * 100) : 0,
    aulasTotais: totalAulas,
    maxAbsences: totalAllowed
  };
}
